import { ActivityIndicator, Image, View } from 'react-native';
import * as AppConstants from "@/utilities/AppConstants";
import { Hourglass } from 'react95-native-rabbl';

function CustomActivityIndicator(props) {
  if (props.hide) {
    return null;
  } else {
    let style = {};

    if (props.absoluteBottom) {
      style = {
        position: "absolute",
        bottom: 0,
        padding: 15,
        left: 0,
        right: 0,
        marginLeft: "auto",
        marginRight: "auto",
      };
    } else if (props.absoluteCenter) {
      style = {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0, 
        justifyContent: 'center',
        alignItems: 'center',
        padding: 15,
      };
    }

    return (
      <View style={style}>
        <Hourglass size={AppConstants.LARGE_HOURGLASS_SIZE} />
      </View>
    );
  }
}

export default CustomActivityIndicator;
